import React  from "react";
import { FormattedMessage } from "../../util/reactIntl";
import css from './UserNotFound.module.css'

const UserNotFound = () => {
    return (
        <div className={css.container}>
            <h2 className={css.title}><FormattedMessage id='UserNotFound.title'/></h2>  
        </div>
    );  
}

export default UserNotFound